import { Vector3, Matrix3 } from '../../../src/js/three.module.js';

export function getIntersectNormal( intersect, normal = new Vector3() ) {

	normal.copy( intersect.face.normal );

	normal.applyMatrix3( new Matrix3().getNormalMatrix( intersect.object.matrixWorld )).normalize();

	if (window.player && window.player.camera && normal.dot( window.player.camera.position.clone().sub( intersect.point ).normalize( )) < 0 ) normal.negate();

	return normal;
}

const DEFAULT_FLOOR_NORMAL = new Vector3( 0, 1, 0 );

export function isUpwardFacingIntersect( intersect ) {

	if (!intersect || !intersect.face) return false;

	let normal = getIntersectNormal( intersect );

	if (isUpwardFacingIntersect.FLOOR_NORMAL == isUpwardFacingIntersect.DEFAULT_FLOOR_NORMAL) {
		return normal.y >= 0.99;	
	} else {
		return normal.dot( isUpwardFacingIntersect.FLOOR_NORMAL ) >= 0.99;
	}
}

isUpwardFacingIntersect.DEFAULT_FLOOR_NORMAL = DEFAULT_FLOOR_NORMAL;
isUpwardFacingIntersect.FLOOR_NORMAL = DEFAULT_FLOOR_NORMAL;

/** @deprecated */
export function isHorizontalIntersectNormal( intersect ) {
	return isUpwardFacingIntersect( intersect );
}
